import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Robot from "../assets/robot.gif";
export default function Welcome( {currentUser} ) {
  const [userName, setUserName] = useState("");
  useEffect(() => {
    if(currentUser)
      setUserName(currentUser.username);
  }, [currentUser]);
  return (
    <Container>
      <img src={Robot} alt="" />
      <h1>
        Welcome, <span>{userName}!</span>
      </h1>
      <h3>Please select a chat to Start messaging.</h3>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: #092635;
  flex-direction: column;
  img {
    height: 20rem;
  }
  span {
    color: #6D67E4;
  }
`;
